var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddCountryNotes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.632324,
    y: 0.628906,
    width: 20,
    height: 20,
    rx: 3.07692,
    fill: "#22D5D5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2731 6.14103C11.2731 5.787 10.9861 5.5 10.6321 5.5C10.2781 5.5 9.99109 5.787 9.99109 6.14103V9.98718H6.14493C5.7909 9.98718 5.50391 10.2742 5.50391 10.6282C5.50391 10.9822 5.7909 11.2692 6.14493 11.2692H9.99108V15.1154C9.99108 15.4694 10.2781 15.7564 10.6321 15.7564C10.9861 15.7564 11.2731 15.4694 11.2731 15.1154V11.2692H15.1193C15.4733 11.2692 15.7603 10.9822 15.7603 10.6282C15.7603 10.2742 15.4733 9.98718 15.1193 9.98718H11.2731V6.14103Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCountryNotes);
export default __webpack_public_path__ + "static/media/add-country-notes.7d518d69dd3f4fdde39d73b0c481da22.svg";
export { ForwardRef as ReactComponent };